<div class="form-group">
    <div class="dropdown-container" tabindex="0" (focusout)="onFocusOut($event)" (keydown)="handleKeyDown($event)"
        [attr.aria-expanded]="isOpen" [attr.aria-haspopup]="true" [attr.role]="'listbox'">
        <div class="dropdown-selected" [class.open]="isOpen" [class.icon]="icon" (click)="toggleDropdown()">

            <span *ngIf="optionTemplate">
                <ng-template [ngTemplateOutlet]="optionTemplate"
                    [ngTemplateOutletContext]="{ $implicit: selectedOption }"></ng-template>
            </span>
            <!-- Default rendering for options if no template is provided -->
            <span *ngIf="!optionTemplate">
                {{ selectedOption?.text || '' }}
            </span>
            <span class="dropdown_icon"><img [attr.src]="icon" *ngIf="icon" /></span>
        </div>
        <label class="dropdown-label" [class.open]="isOpen" [class.selected]="selectedOption?.id"
            *ngIf="label">{{label}}</label>
        <ul class="dropdown-options" *ngIf="isOpen" [attr.role]="'listbox'" aria-label="Dropdown options">
            <li class="dropdown-search">
                <svg class="dropdown-search-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
                <input type="text" class="dropdown-search-input" [(ngModel)]="searchText"
                    (ngModelChange)="onSearchChange()" [placeholder]="searchPlaceholder" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search" />
            </li>
            <li *ngFor="let option of filteredOptions; let i = index"
                [class.selected]="option.id === selectedOption?.id" [class.focused]="i === focusedIndex"
                (click)="selectOption(option)" [attr.role]="'option'"
                [attr.aria-selected]="option.id === selectedOption?.id">
                <span *ngIf="optionTemplate">
                    <ng-template [ngTemplateOutlet]="optionTemplate"
                        [ngTemplateOutletContext]="{ $implicit: option }"></ng-template>
                </span>

                <!-- Default rendering for options if no template is provided -->
                <span *ngIf="!optionTemplate">
                    <span>
                        {{ option.text }}
                    </span>
                </span>
            </li>
        </ul>
    </div>
    <div class="text-danger" *ngIf="submitted && formGroup.get(controlName)?.errors?.required">
        <label class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
            <img src="/assets/external/warnning-vector.svg" class="img-fluid pr-1" />
            {{ errorMessage }}
        </label>
    </div>
</div>